import cn from 'classnames';

import TextInput from 'components/form-elements/text-input/TextInput';

import { IInputEmail } from 'source/NFR.types';

interface InputEmailProps extends IInputEmail {
  isValid: boolean | null;
  setIsValid: (isValid: boolean) => void;
}

const InputEmail: React.FC<InputEmailProps> = ({ name, label, value, validationError, isValid, setIsValid }) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const isValidEmail = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i.test(input);
    setIsValid(isValidEmail);
  };
  return (
    <div className={cn('input-email', { 'input-email--invalid': isValid === false })}>
      <TextInput onChange={onChange} name={name} value={value} label={label} icon="mail-square" iconFill />
      {isValid === false && <div className="input-email--error">{validationError}</div>}
    </div>
  );
};

InputEmail.displayName = 'InputEmail';

export default InputEmail;
